<template>
  <q-layout view="lHh Lpr lFf" class="bg-grey-1">
    <!--  ЛЕВО МЕНИ -->
    <q-drawer
      v-model="drawer"
      show-if-above
      side="left"
      class="bg-white main-drawer"
    >
      <!--  Лого -->
      <div class="text-center q-pa-md border-bottom">
        <img src="@/assets/logo.png" alt="Лого" class="menu-logo" />
      </div>

      <!--  МЕНИ ЛИНКОВИ -->
      <q-list class="q-pt-md">
        <!--  Прегледи + ЕДНО подмени -->
        <q-expansion-item
          expand-separator
          :default-opened="isPreglediArea"
          class="pregledi-expansion"
          header-class="pregledi-header"
        >
          <template v-slot:header>
            <q-item-section avatar>
              <q-icon name="list" color="mint" />
            </q-item-section>
            <q-item-section>Прегледи</q-item-section>
          </template>

          <!-- Сите барања (главен преглед) -->
          <q-item
            clickable
            v-ripple
            to="/vraboten/pregledi"
            exact
            class="sub-item"
          >
            <q-item-section avatar class="sub-avatar">
              <!-- <q-icon name="inbox" color="mint" size="18px" /> -->
            </q-item-section>
            <q-item-section class="sub-text">
              Преглед на сите барања без фази
            </q-item-section>
          </q-item>

          <!--  ЕДНО подмени: Преглед по фази -->
          <q-item
            clickable
            v-ripple
            to="/vraboten/pregledi/po-fazi"
            exact
            class="sub-item"
          >
            <q-item-section avatar class="sub-avatar">
              <!-- <q-icon name="account_tree" color="mint" size="18px" /> -->
            </q-item-section>
            <q-item-section class="sub-text">
              Преглед по фази
            </q-item-section>
          </q-item>
        </q-expansion-item>

        <!-- Отворање нов налог -->
        <q-item clickable v-ripple to="/vraboten/azuriranje-nalozi" exact>
          <q-item-section avatar>
            <q-icon name="edit_note" color="mint" />
          </q-item-section>
          <q-item-section>Отворање нов налог</q-item-section>
        </q-item>

        <!-- Телефонски повици -->
        <q-item clickable v-ripple to="/vraboten/telefonski-povici" exact>
          <q-item-section avatar>
            <q-icon name="call" color="mint" />
          </q-item-section>
          <q-item-section>Телефонски повици</q-item-section>
        </q-item>

        <!-- Преглед по вработени -->
        <q-item clickable v-ripple to="/vraboten/izvestai" exact>
          <q-item-section avatar>
            <q-icon name="bar_chart" color="mint" />
          </q-item-section>
          <q-item-section>Преглед по вработени</q-item-section>
        </q-item>

        <!-- Додвање на вработен -->
        <q-item clickable v-ripple to="/vraboten/podesuvanja" exact>
          <q-item-section avatar>
            <q-icon name="tune" color="mint" />
          </q-item-section>
          <q-item-section>Додвање на вработен</q-item-section>
        </q-item>
      </q-list>

      <!--  Одјава фиксирана долу -->
      <div class="logout-fixed">
        <q-btn
          outline
          color="mint"
          icon="logout"
          label="Одјави се"
          class="logout-btn full-width"
          @click="logout"
        />
      </div>
    </q-drawer>

    <!-- ГОРЕН БАР -->
    <q-header class="bg-white text-dark border-bottom shadow-1">
      <q-toolbar class="q-px-md">
        <div class="menu-toggle" @click="drawer = !drawer">
          <q-icon name="menu" size="22px" color="white" />
        </div>

        <q-toolbar-title class="text-mint text-weight-bold">
          {{ pageTitle }}
        </q-toolbar-title>
      </q-toolbar>
    </q-header>

    <!--  СОДРЖИНА -->
    <q-page-container>
      <router-view :key="$route.fullPath" />
    </q-page-container>
  </q-layout>
</template>

<script>
export default {
  name: "VrabotenLayout",

  data() {
    return {
      drawer: true,

      //  8 часа
      SESSION_MS: 8 * 60 * 60 * 1000,

      //  тајмер reference
      autoLogoutTimer: null,
    };
  },

  computed: {
    isPreglediArea() {
      return this.$route.path.startsWith("/vraboten/pregledi");
    },

    pageTitle() {
      const full = this.$route.path;

      const titles = {
        "/vraboten/pregledi": "Преглед на барања",
        "/vraboten/pregledi/po-fazi": "Преглед по фази",
        "/vraboten/azuriranje-nalozi": "Отворање нов налог",
        "/vraboten/telefonski-povici": "Телефонски повици",
        "/vraboten/izvestai": "Преглед по вработени",
        "/vraboten/podesuvanja": "Подесувања",
      };

      return titles[full] || "Работен панел";
    },
  },

  methods: {
    //  Автоматски logout (без порака)
    logoutAuto() {
      localStorage.removeItem("user");
      if (this.autoLogoutTimer) clearTimeout(this.autoLogoutTimer);
      this.$router.replace("/najava-vraboten");
    },

    // Постави auto logout тајмер
    setupAutoLogout() {
      const raw = localStorage.getItem("user");
      if (!raw) return;

      let user = null;
      try {
        user = JSON.parse(raw);
      } catch (e) {
        return;
      }

      // ако нема loginAt (стар user), постави сега
      if (!user.loginAt) {
        user.loginAt = Date.now();
        localStorage.setItem("user", JSON.stringify(user));
      }

      const expiresAt = Number(user.loginAt) + this.SESSION_MS;
      const remaining = expiresAt - Date.now();

      if (remaining <= 0) {
        this.logoutAuto();
        return;
      }

      if (this.autoLogoutTimer) clearTimeout(this.autoLogoutTimer);

      this.autoLogoutTimer = setTimeout(() => {
        this.logoutAuto();
      }, remaining);
    },

    //  Рачен logout (копчето си останува со порака)
    logout() {
      localStorage.removeItem("user");
      if (this.autoLogoutTimer) clearTimeout(this.autoLogoutTimer);

      this.$router.replace("/najava-vraboten");
      this.$q.notify({
        color: "mint",
        message: "Успешно се одјавивте.",
        icon: "logout",
      });
    },
  },

  mounted() {
    this.setupAutoLogout();
  },

  beforeDestroy() {
    if (this.autoLogoutTimer) clearTimeout(this.autoLogoutTimer);
  },
};
</script>


<style scoped>
.text-mint { color: #0e6b5f !important; }
.bg-grey-1 { background-color: #f5f6f6 !important; }
.border-bottom { border-bottom: 1px solid #e0e0e0; }

.main-drawer {
  width: 240px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-right: 1px solid #e0e0e0;
  position: relative;
}

.menu-logo { width: 120px; border-radius: 6px; opacity: 0.9; }

.q-item.q-router-link--active {
  background-color: #e9f8f6 !important;
  border-left: 3px solid #0e6b5f;
  color: #0e6b5f !important;
  transition: 0.25s ease;
}
.q-item:hover { background-color: #f3fbfa !important; }

.pregledi-header { color: #0e6b5f; font-weight: 600; }

.sub-item { padding: 4px 12px 4px 18px; min-height: 34px; }
.sub-text { font-size: 12.5px; color: #4b4b4b; }
.sub-avatar { min-width: 32px; }

.logout-fixed {
  position: absolute;
  bottom: 15px;
  left: 0;
  width: 100%;
  padding: 0 12px;
}
.logout-btn {
  font-weight: 600;
  border-radius: 10px;
  transition: all 0.25s ease;
}
.logout-btn:hover {
  background-color: #0e6b5f !important;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 2px 6px rgba(14, 107, 95, 0.25);
}

.menu-toggle {
  width: 40px;
  height: 36px;
  background-color: #1e5048;
  border: 1px solid #0e6b5f;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: all 0.25s ease;
}
.menu-toggle:hover { background-color: #0e6b5f; transform: scale(1.05); }
.menu-toggle:active { transform: scale(0.95); }

@media (max-width: 768px) {
  .menu-logo { width: 90px; }
  .q-toolbar-title { font-size: 15px; }
}
</style>
